import { useEffect } from 'react';
import { subscribeSocketConnected } from '../services/socket';
import { useTournamentStore } from '../store/tournament-store';

/**
 * Al ritorno del socket, il torneo in pagina si rilegge e — se ci sono
 * iscritto e il torneo e' in corso — ci si rientra. Vedi
 * `dopoLaRiconnessione` nello store.
 *
 * Un hook montato una volta in `App` e non dentro le schermate del torneo:
 * il torneo caricato resta nello store anche quando si passa a un'altra
 * schermata — la partita, la lobby, la dashboard fra un turno e l'altro — e
 * chi ci e' iscritto deve tornare «presente» per il server qualunque
 * schermata ci sia in quel momento.
 *
 * Non un callback di `initSocket`: quel registro e' unito per chiave, e una
 * chiave `onConnect` registrata qui strapperebbe al multiplayer il suo
 * rientro in partita (la nota sta in `tournament-store.ts`, `connect`).
 */
export function useTorneoDopoLaRiconnessione(): void {
  useEffect(
    () => subscribeSocketConnected(() => {
      void useTournamentStore.getState().dopoLaRiconnessione();
    }),
    [],
  );
}
